export default () => ({
  protocolArray: [],
  protocolCounter: 0,
  loadingState: true
});